export default __webpack_public_path__ + "static/media/unlink.c4b55faa.svg";